import React from 'react';
import LocationTemplate from './LocationTemplate';

const JacksonvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Jacksonville"
      stateName="North Carolina"
      countyName="Onslow"
      zipCodes={["28540", "28541", "28544", "28546"]}
      latitude={34.7540}
      longitude={-77.4300}
      population={72723}
      historicalFact="Home to Marine Corps Base Camp Lejeune, one of the largest military installations in the world."
      nearbyTowns={[
        "Camp Lejeune, NC",
        "Swansboro, NC",
        "Richlands, NC",
        "Sneads Ferry, NC",
        "Hubert, NC",
        "Maysville, NC",
        "Trenton, NC",
        "New Bern, NC"
      ]}
    />
  );
};

export default JacksonvillePage;